import { render, staticRenderFns } from "./55.vue?vue&type=template&id=2c86fbf1&scoped=true&"
import script from "./55.vue?vue&type=script&lang=js&"
export * from "./55.vue?vue&type=script&lang=js&"
import style0 from "./55.vue?vue&type=style&index=0&id=2c86fbf1&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c86fbf1",
  null
  
)

export default component.exports